module.exports = __webpack_public_path__ + "920237deb022027379dfcaedfa11cc41.png";